import React from 'react';
import ReactDOM from 'react-dom';

import { Provider } from 'react-redux';
import { store } from './store/index';
import { AppRouter } from './router/AppRouter'

import './styles.css';
import "./assets/css/material-dashboard-react.css?v=1.10.0";
// import 'semantic-ui-css/semantic.min.css';

ReactDOM.render(
  <Provider store={ store }>
    <AppRouter />
  </Provider>,
  document.getElementById('root')
);


